<template>
  <lwf-badge
    v-bind="$attrs"
    :label="labels[value ? 1 : 0]"
    :color="colors[value ? 1 : 0]"
  />
</template>

<script>
import LwfBadge from 'components/core/LwfBadge'

export default {
  name: 'LwfBadgeBool',
  components: { LwfBadge },
  inheritAttrs: false,
  props: {
    value: Boolean,
    labels: {
      type: Array,
      default: () => ['Non', 'Oui']
    },
    colors: {
      type: Array,
      default: () => ['negative', 'positive']
    }
  }
}
</script>

<style scoped>

</style>
